export const isUserPaymentMethodAutoAssigned = (state) => state.entities.users.paymentMethodAutoAssigned;
